import React from "react";
import "./Green_Outline_Btn.css";
import { Button } from "react-bootstrap";

function Green_Outline_Btn({ btnText, onClick, disabled }) {
  return (
    <>
      <section className="Green_Outline_Btn_holder">
        <Button
          className="Green_Outline_Btn"
          onClick={onClick}
          disabled={disabled}
        >
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Green_Outline_Btn;
